import { Entity } from './base-entity.model';

export class Onboarding extends Entity {
  messages: any[];
  idRoom: string;
  imgUrl: string;
  members: number[];
  name: string;
}
